var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-list-table',{attrs:{"title":_vm.title,"data-service":_vm.dataService,"headers":_vm.headers,"create-route-name":_vm.createRouteName,"edit-route-name":_vm.editRouteName,"show-status-column":false,"allow-delete":false},scopedSlots:_vm._u([{key:"item.effectiveDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatEffectiveDate(item.effectiveDate))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }